export default __webpack_public_path__ + "static/creators-illustration-light-2fe2adcf164aa33c5eff87cb115c2e18.svg";